function plausible(eventName, opts) {
  if (!window.plausible) {
    return;
  }

  if (!opts && window.plausibleConfig) {
    opts = window.plausibleConfig; // child themes sets this in head.blade.php to prefix URL path with their domain
  }

  if (!opts) {
    opts = {};
  }

  window.plausible(eventName, opts);
}

const events = [
  () => {
    const cb = (evt) => {
      if (evt.target.closest("a[href^='mailto:']")) {
        plausible("Email click");
      }
    };

    window.addEventListener("click", cb);

    return () => {
      window.removeEventListener("click", cb);
    };
  },
  () => {
    const cb = (evt) => {
      if (evt.target.closest("a[href^='tel:']")) {
        plausible("Phone click");
      }
    };

    window.addEventListener("click", cb);

    return () => {
      window.removeEventListener("click", cb);
    };
  },
  () => {
    const cb = (evt) => {
      plausible("Main form submission");
    };

    window.addEventListener("member.submission", cb);

    return () => {
      window.removeEventListener("member.submission", cb);
    };
  },
];

let cleanups = [];

export default function () {
  events.forEach((event) => {
    cleanups.push(event());
  });

  return {
    destroy() {
      cleanups.forEach((cleanup) => cleanup());
    },
  };
}
